import classNames from 'classnames';
import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import Tooltip from '../../components/Tooltip';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import getUserNames from '../../user/getUserNames';
import * as styles from './CommentReactionList.module.scss';
import Emoji from './Emoji';
import groupReactions from './groupReactions';

export const COMMENT_REACTION_LIST_REACTIONS_FRAGMENT = gql(`
  fragment CommentReactionList_reactions on CommentReaction {
    id
    author {
      ...getUserNames_user
    }
    ...groupReactions_commentReactions
  }
`);

interface CommentReactionListProps {
  reactions: DocumentType<typeof COMMENT_REACTION_LIST_REACTIONS_FRAGMENT>[];
  toggleCommentReaction?: (emoji: string) => void;
  variant?: 'inset' | 'insetPlus';
}

const CommentReactionList = ({
  reactions,
  toggleCommentReaction,
  variant = 'inset',
}: CommentReactionListProps) => {
  const currentUser = useAppSelector((state) => state.session.user);

  return (
    <div
      className={classNames(styles.container, {
        [styles.inset]: variant === 'inset',
        [styles.insetPlus]: variant === 'insetPlus',
      })}
    >
      {groupReactions(reactions, currentUser.id).map(
        ({ emoji, items, isActive }) => {
          const content = (
            <>
              <Emoji char={emoji} size="small" />
              {items.length > 1 && (
                <div className={styles.count}>{items.length}</div>
              )}
            </>
          );

          const className = classNames(styles.item, {
            [styles.active]: isActive,
          });

          return (
            <Tooltip
              key={emoji}
              content={getUserNames(
                items.map(({ author }) => author),
                { currentUser, limit: 20 },
              )}
            >
              {toggleCommentReaction ? (
                <button
                  type="button"
                  className={className}
                  onClick={() => toggleCommentReaction(emoji)}
                >
                  {content}
                </button>
              ) : (
                <div className={className}>{content}</div>
              )}
            </Tooltip>
          );
        },
      )}
    </div>
  );
};

export default CommentReactionList;
